"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file player.proto (package player, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateReferralResponse = exports.UpdateReferralRequest = exports.GetAuthCodeResponse = exports.GetAuthCodeRequest = exports.CreateAuthCodeResponse = exports.CreateAuthCodeRequest = exports.GetPlayerResponse = exports.PrivilegeUpdateMessage = exports.SimplePlayer = exports.BasicEventPlayer = exports.GetPlayerRequest = exports.KeyValue = exports.UpdatePlayerSettingRequest = exports.SetPrivilegesResponse = exports.SetPrivilegesRequest = exports.GetPlayersResponse = exports.UpdatePlayerAttendanceResponse = exports.UpdatePlayerAttendanceRequest = exports.GetPlayerAttendanceResponse = exports.PlayerAttendance = exports.GetPlayerAttendanceRequest = exports.GetPlayersRequest = exports.GetTicketResponse = exports.GetTicketRequest = exports.SearchPlayerResponse = exports.SearchPlayerRequest = exports.PrivilegeSubscribeRequest = exports.GetPlayerIdResponse = exports.GetPlayerIdRequest = exports.Guest = exports.GetGuestsResponse = exports.GetGuestsRequest = exports.PlayerEntitlementName = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const common_pb_js_1 = require("./common_pb.js");
const rank_pb_js_1 = require("./rank_pb.js");
/**
 * @generated from enum player.PlayerEntitlementName
 */
var PlayerEntitlementName;
(function (PlayerEntitlementName) {
    /**
     * @generated from enum value: VISITOR = 0;
     */
    PlayerEntitlementName[PlayerEntitlementName["VISITOR"] = 0] = "VISITOR";
    /**
     * @generated from enum value: ATTENDEE = 1;
     */
    PlayerEntitlementName[PlayerEntitlementName["ATTENDEE"] = 1] = "ATTENDEE";
    /**
     * @generated from enum value: JUNIOR_EXHIBITOR = 2;
     */
    PlayerEntitlementName[PlayerEntitlementName["JUNIOR_EXHIBITOR"] = 2] = "JUNIOR_EXHIBITOR";
    /**
     * @generated from enum value: EXHIBITOR = 3;
     */
    PlayerEntitlementName[PlayerEntitlementName["EXHIBITOR"] = 3] = "EXHIBITOR";
    /**
     * @generated from enum value: VIP = 4;
     */
    PlayerEntitlementName[PlayerEntitlementName["VIP"] = 4] = "VIP";
    /**
     * @generated from enum value: VIP_PLUS = 5;
     */
    PlayerEntitlementName[PlayerEntitlementName["VIP_PLUS"] = 5] = "VIP_PLUS";
    /**
     * @generated from enum value: VIP_ULTRA = 6;
     */
    PlayerEntitlementName[PlayerEntitlementName["VIP_ULTRA"] = 6] = "VIP_ULTRA";
    /**
     * @generated from enum value: SPONSOR = 7;
     */
    PlayerEntitlementName[PlayerEntitlementName["SPONSOR"] = 7] = "SPONSOR";
    /**
     * @generated from enum value: GUEST = 8;
     */
    PlayerEntitlementName[PlayerEntitlementName["GUEST"] = 8] = "GUEST";
    /**
     * @generated from enum value: STICKYPISTON = 9;
     */
    PlayerEntitlementName[PlayerEntitlementName["STICKYPISTON"] = 9] = "STICKYPISTON";
    /**
     * @generated from enum value: STAFF = 10;
     */
    PlayerEntitlementName[PlayerEntitlementName["STAFF"] = 10] = "STAFF";
    /**
     * @generated from enum value: MODERATION = 11;
     */
    PlayerEntitlementName[PlayerEntitlementName["MODERATION"] = 11] = "MODERATION";
    /**
     * @generated from enum value: OPERATIONS = 12;
     */
    PlayerEntitlementName[PlayerEntitlementName["OPERATIONS"] = 12] = "OPERATIONS";
    /**
     * @generated from enum value: PRODUCTION = 13;
     */
    PlayerEntitlementName[PlayerEntitlementName["PRODUCTION"] = 13] = "PRODUCTION";
    /**
     * @generated from enum value: MAIN_STAGE_ACCESS = 14;
     */
    PlayerEntitlementName[PlayerEntitlementName["MAIN_STAGE_ACCESS"] = 14] = "MAIN_STAGE_ACCESS";
    /**
     * @generated from enum value: OUTDOOR_STAGE_ACCESS = 15;
     */
    PlayerEntitlementName[PlayerEntitlementName["OUTDOOR_STAGE_ACCESS"] = 15] = "OUTDOOR_STAGE_ACCESS";
    /**
     * @generated from enum value: DEV_ACCESS = 16;
     */
    PlayerEntitlementName[PlayerEntitlementName["DEV_ACCESS"] = 16] = "DEV_ACCESS";
    /**
     * @generated from enum value: BUILD_ACCESS = 17;
     */
    PlayerEntitlementName[PlayerEntitlementName["BUILD_ACCESS"] = 17] = "BUILD_ACCESS";
    /**
     * @generated from enum value: GOLD_TICKET = 18;
     */
    PlayerEntitlementName[PlayerEntitlementName["GOLD_TICKET"] = 18] = "GOLD_TICKET";
})(PlayerEntitlementName = exports.PlayerEntitlementName || (exports.PlayerEntitlementName = {}));
// Retrieve enum metadata with: proto3.getEnumType(PlayerEntitlementName)
protobuf_1.proto3.util.setEnumType(PlayerEntitlementName, "player.PlayerEntitlementName", [
    { no: 0, name: "VISITOR" },
    { no: 1, name: "ATTENDEE" },
    { no: 2, name: "JUNIOR_EXHIBITOR" },
    { no: 3, name: "EXHIBITOR" },
    { no: 4, name: "VIP" },
    { no: 5, name: "VIP_PLUS" },
    { no: 6, name: "VIP_ULTRA" },
    { no: 7, name: "SPONSOR" },
    { no: 8, name: "GUEST" },
    { no: 9, name: "STICKYPISTON" },
    { no: 10, name: "STAFF" },
    { no: 11, name: "MODERATION" },
    { no: 12, name: "OPERATIONS" },
    { no: 13, name: "PRODUCTION" },
    { no: 14, name: "MAIN_STAGE_ACCESS" },
    { no: 15, name: "OUTDOOR_STAGE_ACCESS" },
    { no: 16, name: "DEV_ACCESS" },
    { no: 17, name: "BUILD_ACCESS" },
    { no: 18, name: "GOLD_TICKET" },
]);
/**
 * @generated from message player.GetGuestsRequest
 */
class GetGuestsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetGuestsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGuestsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGuestsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetGuestsRequest, a, b);
    }
}
GetGuestsRequest.runtime = protobuf_1.proto3;
GetGuestsRequest.typeName = "player.GetGuestsRequest";
GetGuestsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
exports.GetGuestsRequest = GetGuestsRequest;
/**
 * @generated from message player.GetGuestsResponse
 */
class GetGuestsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated player.Guest guest = 1;
         */
        this.guest = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetGuestsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGuestsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGuestsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetGuestsResponse, a, b);
    }
}
GetGuestsResponse.runtime = protobuf_1.proto3;
GetGuestsResponse.typeName = "player.GetGuestsResponse";
GetGuestsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "guest", kind: "message", T: Guest, repeated: true },
]);
exports.GetGuestsResponse = GetGuestsResponse;
/**
 * @generated from message player.Guest
 */
class Guest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: string link = 2;
         */
        this.link = "";
        /**
         * @generated from field: string avatar = 3;
         */
        this.avatar = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Guest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Guest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Guest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Guest, a, b);
    }
}
Guest.runtime = protobuf_1.proto3;
Guest.typeName = "player.Guest";
Guest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.Guest = Guest;
/**
 * @generated from message player.GetPlayerIdRequest
 */
class GetPlayerIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string username = 1;
         */
        this.username = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerIdRequest, a, b);
    }
}
GetPlayerIdRequest.runtime = protobuf_1.proto3;
GetPlayerIdRequest.typeName = "player.GetPlayerIdRequest";
GetPlayerIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.GetPlayerIdRequest = GetPlayerIdRequest;
/**
 * @generated from message player.GetPlayerIdResponse
 */
class GetPlayerIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerIdResponse, a, b);
    }
}
GetPlayerIdResponse.runtime = protobuf_1.proto3;
GetPlayerIdResponse.typeName = "player.GetPlayerIdResponse";
GetPlayerIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.GetPlayerIdResponse = GetPlayerIdResponse;
/**
 * @generated from message player.PrivilegeSubscribeRequest
 */
class PrivilegeSubscribeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PrivilegeSubscribeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrivilegeSubscribeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrivilegeSubscribeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PrivilegeSubscribeRequest, a, b);
    }
}
PrivilegeSubscribeRequest.runtime = protobuf_1.proto3;
PrivilegeSubscribeRequest.typeName = "player.PrivilegeSubscribeRequest";
PrivilegeSubscribeRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
exports.PrivilegeSubscribeRequest = PrivilegeSubscribeRequest;
/**
 * @generated from message player.SearchPlayerRequest
 */
class SearchPlayerRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SearchPlayerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchPlayerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchPlayerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SearchPlayerRequest, a, b);
    }
}
SearchPlayerRequest.runtime = protobuf_1.proto3;
SearchPlayerRequest.typeName = "player.SearchPlayerRequest";
SearchPlayerRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.SearchPlayerRequest = SearchPlayerRequest;
/**
 * @generated from message player.SearchPlayerResponse
 */
class SearchPlayerResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated player.SimplePlayer players = 1;
         */
        this.players = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SearchPlayerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchPlayerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchPlayerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SearchPlayerResponse, a, b);
    }
}
SearchPlayerResponse.runtime = protobuf_1.proto3;
SearchPlayerResponse.typeName = "player.SearchPlayerResponse";
SearchPlayerResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "players", kind: "message", T: SimplePlayer, repeated: true },
]);
exports.SearchPlayerResponse = SearchPlayerResponse;
/**
 * @generated from message player.GetTicketRequest
 */
class GetTicketRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof player.GetTicketRequest.player
         */
        this.player = { case: undefined };
        /**
         * @generated from field: string email = 3;
         */
        this.email = "";
        /**
         * @generated from field: bool marketing = 4;
         */
        this.marketing = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetTicketRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTicketRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTicketRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetTicketRequest, a, b);
    }
}
GetTicketRequest.runtime = protobuf_1.proto3;
GetTicketRequest.typeName = "player.GetTicketRequest";
GetTicketRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "javaInformation", kind: "message", T: common_pb_js_1.PlayerInformation, oneof: "player" },
    { no: 2, name: "gamertag", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "player" },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "marketing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.GetTicketRequest = GetTicketRequest;
/**
 * @generated from message player.GetTicketResponse
 */
class GetTicketResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetTicketResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTicketResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTicketResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetTicketResponse, a, b);
    }
}
GetTicketResponse.runtime = protobuf_1.proto3;
GetTicketResponse.typeName = "player.GetTicketResponse";
GetTicketResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "existed", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "rank", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "gold", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
]);
exports.GetTicketResponse = GetTicketResponse;
/**
 * @generated from message player.GetPlayersRequest
 */
class GetPlayersRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated int32 rankIds = 1;
         */
        this.rankIds = [];
        /**
         * @generated from field: repeated int32 roleIds = 2;
         */
        this.roleIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayersRequest, a, b);
    }
}
GetPlayersRequest.runtime = protobuf_1.proto3;
GetPlayersRequest.typeName = "player.GetPlayersRequest";
GetPlayersRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "rankIds", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "roleIds", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
]);
exports.GetPlayersRequest = GetPlayersRequest;
/**
 * @generated from message player.GetPlayerAttendanceRequest
 */
class GetPlayerAttendanceRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerAttendanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerAttendanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerAttendanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerAttendanceRequest, a, b);
    }
}
GetPlayerAttendanceRequest.runtime = protobuf_1.proto3;
GetPlayerAttendanceRequest.typeName = "player.GetPlayerAttendanceRequest";
GetPlayerAttendanceRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
]);
exports.GetPlayerAttendanceRequest = GetPlayerAttendanceRequest;
/**
 * @generated from message player.PlayerAttendance
 */
class PlayerAttendance extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 year = 1;
         */
        this.year = 0;
        /**
         * @generated from field: repeated string ranks = 2;
         */
        this.ranks = [];
        /**
         * @generated from field: bool ticket = 3;
         */
        this.ticket = false;
        /**
         * @generated from field: bool exhibitor = 4;
         */
        this.exhibitor = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlayerAttendance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlayerAttendance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlayerAttendance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PlayerAttendance, a, b);
    }
}
PlayerAttendance.runtime = protobuf_1.proto3;
PlayerAttendance.typeName = "player.PlayerAttendance";
PlayerAttendance.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "ranks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "ticket", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "exhibitor", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "joined", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
]);
exports.PlayerAttendance = PlayerAttendance;
/**
 * @generated from message player.GetPlayerAttendanceResponse
 */
class GetPlayerAttendanceResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated player.PlayerAttendance years = 1;
         */
        this.years = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerAttendanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerAttendanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerAttendanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerAttendanceResponse, a, b);
    }
}
GetPlayerAttendanceResponse.runtime = protobuf_1.proto3;
GetPlayerAttendanceResponse.typeName = "player.GetPlayerAttendanceResponse";
GetPlayerAttendanceResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "years", kind: "message", T: PlayerAttendance, repeated: true },
]);
exports.GetPlayerAttendanceResponse = GetPlayerAttendanceResponse;
/**
 * @generated from message player.UpdatePlayerAttendanceRequest
 */
class UpdatePlayerAttendanceRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdatePlayerAttendanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePlayerAttendanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePlayerAttendanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UpdatePlayerAttendanceRequest, a, b);
    }
}
UpdatePlayerAttendanceRequest.runtime = protobuf_1.proto3;
UpdatePlayerAttendanceRequest.typeName = "player.UpdatePlayerAttendanceRequest";
UpdatePlayerAttendanceRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "ticket", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "joined", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
]);
exports.UpdatePlayerAttendanceRequest = UpdatePlayerAttendanceRequest;
/**
 * @generated from message player.UpdatePlayerAttendanceResponse
 */
class UpdatePlayerAttendanceResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdatePlayerAttendanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePlayerAttendanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePlayerAttendanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UpdatePlayerAttendanceResponse, a, b);
    }
}
UpdatePlayerAttendanceResponse.runtime = protobuf_1.proto3;
UpdatePlayerAttendanceResponse.typeName = "player.UpdatePlayerAttendanceResponse";
UpdatePlayerAttendanceResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
exports.UpdatePlayerAttendanceResponse = UpdatePlayerAttendanceResponse;
/**
 * @generated from message player.GetPlayersResponse
 */
class GetPlayersResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated player.BasicEventPlayer players = 1;
         */
        this.players = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayersResponse, a, b);
    }
}
GetPlayersResponse.runtime = protobuf_1.proto3;
GetPlayersResponse.typeName = "player.GetPlayersResponse";
GetPlayersResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "players", kind: "message", T: BasicEventPlayer, repeated: true },
]);
exports.GetPlayersResponse = GetPlayersResponse;
/**
 * @generated from message player.SetPrivilegesRequest
 */
class SetPrivilegesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated int32 rank = 2;
         */
        this.rank = [];
        /**
         * @generated from field: repeated player.PlayerEntitlementName entitlement = 3;
         */
        this.entitlement = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SetPrivilegesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrivilegesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrivilegesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SetPrivilegesRequest, a, b);
    }
}
SetPrivilegesRequest.runtime = protobuf_1.proto3;
SetPrivilegesRequest.typeName = "player.SetPrivilegesRequest";
SetPrivilegesRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "rank", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "entitlement", kind: "enum", T: protobuf_1.proto3.getEnumType(PlayerEntitlementName), repeated: true },
]);
exports.SetPrivilegesRequest = SetPrivilegesRequest;
/**
 * @generated from message player.SetPrivilegesResponse
 */
class SetPrivilegesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SetPrivilegesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrivilegesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrivilegesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SetPrivilegesResponse, a, b);
    }
}
SetPrivilegesResponse.runtime = protobuf_1.proto3;
SetPrivilegesResponse.typeName = "player.SetPrivilegesResponse";
SetPrivilegesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.SetPrivilegesResponse = SetPrivilegesResponse;
/**
 * @generated from message player.UpdatePlayerSettingRequest
 */
class UpdatePlayerSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdatePlayerSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePlayerSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePlayerSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UpdatePlayerSettingRequest, a, b);
    }
}
UpdatePlayerSettingRequest.runtime = protobuf_1.proto3;
UpdatePlayerSettingRequest.typeName = "player.UpdatePlayerSettingRequest";
UpdatePlayerSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "setting", kind: "message", T: KeyValue },
]);
exports.UpdatePlayerSettingRequest = UpdatePlayerSettingRequest;
/**
 * @generated from message player.KeyValue
 */
class KeyValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KeyValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(KeyValue, a, b);
    }
}
KeyValue.runtime = protobuf_1.proto3;
KeyValue.typeName = "player.KeyValue";
KeyValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.KeyValue = KeyValue;
/**
 * @generated from message player.GetPlayerRequest
 */
class GetPlayerRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 year = 2;
         */
        this.year = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerRequest, a, b);
    }
}
GetPlayerRequest.runtime = protobuf_1.proto3;
GetPlayerRequest.typeName = "player.GetPlayerRequest";
GetPlayerRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.GetPlayerRequest = GetPlayerRequest;
/**
 * @generated from message player.BasicEventPlayer
 */
class BasicEventPlayer extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uuid = 1;
         */
        this.uuid = "";
        /**
         * @generated from field: string username = 2;
         */
        this.username = "";
        /**
         * @generated from field: repeated rank.EventRank ranks = 3;
         */
        this.ranks = [];
        /**
         * @generated from field: repeated player.PlayerEntitlementName entitlements = 4;
         */
        this.entitlements = [];
        /**
         * @generated from field: repeated player.KeyValue settings = 5;
         */
        this.settings = [];
        /**
         * @generated from field: repeated player.KeyValue properties = 6;
         */
        this.properties = [];
        /**
         * @generated from field: repeated int32 roles = 7;
         */
        this.roles = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BasicEventPlayer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BasicEventPlayer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BasicEventPlayer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(BasicEventPlayer, a, b);
    }
}
BasicEventPlayer.runtime = protobuf_1.proto3;
BasicEventPlayer.typeName = "player.BasicEventPlayer";
BasicEventPlayer.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ranks", kind: "message", T: rank_pb_js_1.EventRank, repeated: true },
    { no: 4, name: "entitlements", kind: "enum", T: protobuf_1.proto3.getEnumType(PlayerEntitlementName), repeated: true },
    { no: 5, name: "settings", kind: "message", T: KeyValue, repeated: true },
    { no: 6, name: "properties", kind: "message", T: KeyValue, repeated: true },
    { no: 7, name: "roles", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
]);
exports.BasicEventPlayer = BasicEventPlayer;
/**
 * @generated from message player.SimplePlayer
 */
class SimplePlayer extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uuid = 1;
         */
        this.uuid = "";
        /**
         * @generated from field: string username = 2;
         */
        this.username = "";
        /**
         * @generated from field: repeated int32 ranks = 3;
         */
        this.ranks = [];
        /**
         * @generated from field: repeated player.PlayerEntitlementName entitlements = 4;
         */
        this.entitlements = [];
        /**
         * @generated from field: repeated int32 roles = 5;
         */
        this.roles = [];
        /**
         * @generated from field: int32 priorityRank = 6;
         */
        this.priorityRank = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SimplePlayer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimplePlayer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimplePlayer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SimplePlayer, a, b);
    }
}
SimplePlayer.runtime = protobuf_1.proto3;
SimplePlayer.typeName = "player.SimplePlayer";
SimplePlayer.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ranks", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "entitlements", kind: "enum", T: protobuf_1.proto3.getEnumType(PlayerEntitlementName), repeated: true },
    { no: 5, name: "roles", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "priorityRank", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
exports.SimplePlayer = SimplePlayer;
/**
 * @generated from message player.PrivilegeUpdateMessage
 */
class PrivilegeUpdateMessage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uuid = 1;
         */
        this.uuid = "";
        /**
         * @generated from field: string username = 2;
         */
        this.username = "";
        /**
         * @generated from field: repeated int32 ranks = 3;
         */
        this.ranks = [];
        /**
         * @generated from field: repeated player.PlayerEntitlementName entitlements = 4;
         */
        this.entitlements = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PrivilegeUpdateMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrivilegeUpdateMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrivilegeUpdateMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PrivilegeUpdateMessage, a, b);
    }
}
PrivilegeUpdateMessage.runtime = protobuf_1.proto3;
PrivilegeUpdateMessage.typeName = "player.PrivilegeUpdateMessage";
PrivilegeUpdateMessage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ranks", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "entitlements", kind: "enum", T: protobuf_1.proto3.getEnumType(PlayerEntitlementName), repeated: true },
]);
exports.PrivilegeUpdateMessage = PrivilegeUpdateMessage;
/**
 * @generated from message player.GetPlayerResponse
 */
class GetPlayerResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool found = 1;
         */
        this.found = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetPlayerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlayerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlayerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetPlayerResponse, a, b);
    }
}
GetPlayerResponse.runtime = protobuf_1.proto3;
GetPlayerResponse.typeName = "player.GetPlayerResponse";
GetPlayerResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "found", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "player", kind: "message", T: BasicEventPlayer, opt: true },
]);
exports.GetPlayerResponse = GetPlayerResponse;
/**
 * @generated from message player.CreateAuthCodeRequest
 */
class CreateAuthCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string redirect = 2;
         */
        this.redirect = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateAuthCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuthCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuthCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CreateAuthCodeRequest, a, b);
    }
}
CreateAuthCodeRequest.runtime = protobuf_1.proto3;
CreateAuthCodeRequest.typeName = "player.CreateAuthCodeRequest";
CreateAuthCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "redirect", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.CreateAuthCodeRequest = CreateAuthCodeRequest;
/**
 * @generated from message player.CreateAuthCodeResponse
 */
class CreateAuthCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateAuthCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuthCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuthCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CreateAuthCodeResponse, a, b);
    }
}
CreateAuthCodeResponse.runtime = protobuf_1.proto3;
CreateAuthCodeResponse.typeName = "player.CreateAuthCodeResponse";
CreateAuthCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "expires", kind: "scalar", T: 4 /* ScalarType.UINT64 */, opt: true },
]);
exports.CreateAuthCodeResponse = CreateAuthCodeResponse;
/**
 * @generated from message player.GetAuthCodeRequest
 */
class GetAuthCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string code = 1;
         */
        this.code = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetAuthCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuthCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuthCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetAuthCodeRequest, a, b);
    }
}
GetAuthCodeRequest.runtime = protobuf_1.proto3;
GetAuthCodeRequest.typeName = "player.GetAuthCodeRequest";
GetAuthCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.GetAuthCodeRequest = GetAuthCodeRequest;
/**
 * @generated from message player.GetAuthCodeResponse
 */
class GetAuthCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetAuthCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuthCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuthCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GetAuthCodeResponse, a, b);
    }
}
GetAuthCodeResponse.runtime = protobuf_1.proto3;
GetAuthCodeResponse.typeName = "player.GetAuthCodeResponse";
GetAuthCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "player", kind: "message", T: BasicEventPlayer, opt: true },
    { no: 3, name: "redirect", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.GetAuthCodeResponse = GetAuthCodeResponse;
/**
 * @generated from message player.UpdateReferralRequest
 */
class UpdateReferralRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ref = 2;
         */
        this.ref = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdateReferralRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateReferralRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateReferralRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UpdateReferralRequest, a, b);
    }
}
UpdateReferralRequest.runtime = protobuf_1.proto3;
UpdateReferralRequest.typeName = "player.UpdateReferralRequest";
UpdateReferralRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "identifier", kind: "message", T: common_pb_js_1.PlayerIdentifier },
    { no: 2, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.UpdateReferralRequest = UpdateReferralRequest;
/**
 * @generated from message player.UpdateReferralResponse
 */
class UpdateReferralResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UpdateReferralResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateReferralResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateReferralResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(UpdateReferralResponse, a, b);
    }
}
UpdateReferralResponse.runtime = protobuf_1.proto3;
UpdateReferralResponse.typeName = "player.UpdateReferralResponse";
UpdateReferralResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
exports.UpdateReferralResponse = UpdateReferralResponse;
